import { render, staticRenderFns } from "./ContactMenu.vue?vue&type=template&id=0be1a32c&scoped=true&"
import script from "./ContactMenu.vue?vue&type=script&lang=js&"
export * from "./ContactMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContactMenu.vue?vue&type=style&index=0&id=0be1a32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1a32c",
  null
  
)

export default component.exports